export type DocumentCategory = 'PAYROLL' | 'CONTRACT' | 'CERTIFICATE' | 'OTHER';

export interface DocumentSummary {
  id: string;
  ownerUserId: string;
  ownerName: string;
  uploadedById: string;
  uploadedByName: string;
  category: DocumentCategory;
  title: string;
  filename: string;
  mimeType: string;
  sizeBytes: number;
  periodMonth: number | null;
  periodYear: number | null;
  uploadedAt: string;
}

export const CATEGORY_LABEL: Record<DocumentCategory, string> = {
  PAYROLL: 'Nómina',
  CONTRACT: 'Contrato',
  CERTIFICATE: 'Certificado',
  OTHER: 'Otro',
};

import type { BadgeTone } from '@/pages/absences/types';

export const CATEGORY_TONE: Record<DocumentCategory, BadgeTone> = {
  PAYROLL: 'green',
  CONTRACT: 'blue',
  CERTIFICATE: 'amber',
  OTHER: 'neutral',
};

export const CATEGORIES: DocumentCategory[] = ['PAYROLL', 'CONTRACT', 'CERTIFICATE', 'OTHER'];
